<div
  #mainBox
  [class.top-box]="isTopBox"
  [class.bottom-box]="isBottomBox"
  class="dtt-box pointer data-entry-box"
  (clickOutside)="onClickOutside()"
  [additionalElementRefs]="extraBoxes"
>
  <div
    class="flag flex-column no-select"
    (click)="clickedBox()"
    (mousedown)="startLongPress()"
    (mouseup)="endLongPress($event)"
    (mouseleave)="endLongPress($event)"
    (touchstart)="startLongPress()"
    (touchend)="endLongPress($event)"
    (touchcancel)="endLongPress($event)"
  >
    {{ text }}
    <span *ngIf="lastIntensity != null" class="badge-count">{{ lastIntensity }}</span>
    <span class="badge badge-left">{{ behaviorData.length }}</span>
    <button class="badge-bottom-left" (click)="openDetails($event)">?</button>
  </div>
</div>

@if (detailsOpened) {
<app-target-details
  [behavior]="behavior"
  (onCloseDetails)="onCloseDetails()"
  [isPreview]="isPreview"
></app-target-details>
}

<div class="extra-container" #extraBox [class.hide]="!extraOpened">
  <div class="extra-close" (click)="closeExtra()">X</div>
  <div class="extra-container-textbox">
    <div
      *ngFor="let intensity of intensityOptions"
      class="pointer data-entry-box"
      [class.data-recorded-success]="lastRecordedIntensity === intensity"
      [class.data-buffer-active]="addingBehaviorData && cooldownIntensity === intensity"
      (click)="selectIntensity(intensity)"
    >
      <div class="dtt-option" [style.background-color]="intensityColor(intensity)">
        <span class="dtt-option-icon" [style.color]="intensityColor(intensity)">{{
          intensity
        }}</span>
        <span class="dtt-option-name">Intensity {{ intensity }}</span>
      </div>
      <div
        class="data-entry-cooldown-bar"
        [class.data-entry-cooldown-active]="
          addingBehaviorData && cooldownIntensity === intensity
        "
        aria-hidden="true"
      >
        <div class="data-entry-cooldown-bar-fill"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="extra-container extra-big abc-container"
  #extraBox2
  [class.hide]="!extra2Opened"
>
  <app-abc-data-panel
    #abcDataPanel
    [behaviorID]="behaviorID"
    [sessionValue]="behaviorData.length"
    (setExtraBoxesEvent)="setExtraBoxes()"
    [behaviorType]="behaviorType"
  ></app-abc-data-panel>
</div>
